import React from "react";
import { Accordion, Col, Form, Table } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import {
  formatNumberToLocal,
  hOneCalculation,
  toastError,
} from "../../helpers";
// import heliorOneTncEn from "../../assets/CONTRACT EXCELIOR ONE.pdf";
// import heliorOneTncIt from "../../assets/EXCELIOR ONE25 - ITA.pdf";
// Update Multilingual Contract Docs ER38
import heliorOneTncEn from "../../assets/04_NEG_X-ONE_V7-A2_EN_ES_FR_PL-a85eytag3tdu8xbjjwqi54sx5c.pdf";
import heliorOneTncIt from "../../assets/03_NEG_X-ONE_V7-A2_IT-ntb61q71wjd1trtajgfwn4s6ze.pdf";
import PdfViewer from "../PdfViewer";
import EosKey from "../EosKey";
import { useParams } from "react-router";
import { CURRENCIES, CURRENCY_SYMBOLS } from "../../Constants";
import SelectInput from "../SelectInput";

const HOnePurchaseForm = ({
  inputData,
  setInputData,
  staticValues,
  eosKey,
  refetch,
  currency,
  setCurrency,
  rate,
}) => {
  const currencySymbol = CURRENCY_SYMBOLS[currency ?? "CHF"] ?? (currency ?? "CHF");
  const conv = (v) => formatNumberToLocal((v ?? 0) * (rate ?? 1));
  const { t } = useTranslation();
  const { lang } = useParams();

  const tncFlags = [
    {
      name: "O01",
      code: "O01",
      title: t("xOneTncFlags.O01.title"),
      text: t("xOneTncFlags.O01.text", {
        language: lang === "it" ? "italiano" : "English",
        version: "V7-A2",
      }),
      reference: t("xOneTncFlags.O01.reference"),
    },
    {
      name: "O02",
      code: "O02",
      title: t("xOneTncFlags.O02.title"),
      text: t("xOneTncFlags.O02.text"),
      reference: t("xOneTncFlags.O02.reference"),
    },
    {
      name: "O03",
      code: "O03",
      title: t("xOneTncFlags.O03.title"),
      text: t("xOneTncFlags.O03.text", {
        percentage: `${inputData?.guaranteeMargin ?? 0}%`,
        amount: conv(inputData?.total_payment_with_guarantee_margin ?? 0),
        currency: currencySymbol,
      }),
      reference: t("xOneTncFlags.O03.reference"),
    },
    {
      name: "O04",
      code: "O04",
      title: t("xOneTncFlags.O04.title"),
      text: t("xOneTncFlags.O04.text", {
        duration: `${inputData?.duration ?? 5} ${t("years")}`,
        commencement:
          lang === "it"
            ? "decorrenza dall'acquisto"
            : "starting from purchase",
        annualFeePercentage: "10%",
        renewalPeriod: "365",
        noticePeriodDays: "30",
        acquisitionPeriodYears: "10",
      }),
      reference: t("xOneTncFlags.O04.reference"),
    },
    {
      name: "C01",
      code: "C01",
      title: t("xOneTncFlags.C01.title"),
      text: t("xOneTncFlags.C01.text"),
      reference: t("xOneTncFlags.C01.reference"),
    },
    {
      name: "C02",
      code: "C02",
      title: t("xOneTncFlags.C02.title"),
      text: t("xOneTncFlags.C02.text"),
      reference: t("xOneTncFlags.C02.reference"),
    },
    {
      name: "C03",
      code: "C03",
      title: t("xOneTncFlags.C03.title"),
      text: t("xOneTncFlags.C03.text"),
      reference: t("xOneTncFlags.C03.reference"),
    },
  ];

  const blockchainFlags = [
    {
      name: "B01",
      code: "B01",
      title: t("xOneTncFlags.B01.title"),
      text: t("xOneTncFlags.B01.text", {
        language: lang === "it" ? "italiano" : "English",
        version: "V7-A2",
      }),
      reference: t("xOneTncFlags.B01.reference"),
    },
    {
      name: "B02O",
      code: "B02O",
      title: t("xOneTncFlags.B02O.title"),
      text: t("xOneTncFlags.B02O.text", {
        manualInterventionCost: "100",
        currency: "CHF",
      }),
      reference: t("xOneTncFlags.B02O.reference"),
      dependsOn: "B01",
    },
    {
      name: "B03",
      code: "B03",
      title: t("xOneTncFlags.B03.title"),
      text: t("xOneTncFlags.B03.text"),
      reference: t("xOneTncFlags.B03.reference"),
      dependsOn: "B01",
    },
  ];

  const handleChange = (e, index = null) => {
    const { name, value, checked, type } = e.target;
    setInputData((prevState) => {
      const updatedIngots = prevState.ingots.map((item) => ({ ...item }));
      const updatedState = { ...prevState, ingots: updatedIngots };

      if (type === "checkbox") {
        updatedState[name] = checked;
        if (name === "O01") {
          updatedState.acceptTNC = checked;
        }
        if (name === "B01") {
          updatedState.acceptBlockchain = checked;
          if (!checked) {
            updatedState.B02O = false;
            updatedState.B03 = false;
          }
        }
      } else {
        switch (name) {
          case "quantity": {
            updatedState.ingots = prevState.ingots.map((item, i) =>
              i === index
                ? { ...item, quantity: parseInt(value) || 0 }
                : { ...item }
            );
            break;
          }
          case "duration":
            updatedState.duration = value;
            break;
          default:
            updatedState[name] = value;
            break;
        }
      }

      let result = hOneCalculation(
        staticValues,
        updatedState,
        updatedState.ingots
      );

      if (result?.totalGrams >= 1000000) {
        toastError("", t("maxTotalgramsError"));
        updatedState.ingots = prevState.ingots.map((item, i) =>
          i === index ? { ...item, quantity: 0 } : item
        );
        result = hOneCalculation(
          staticValues,
          updatedState,
          updatedState.ingots
        );
      }
      return result;
    });
  };

  const fileToDisplay = lang === "en" ? heliorOneTncEn : heliorOneTncIt;

  const durationOptions = [
    { value: "1", label: `1 ${t("years")}`, disabled: inputData.totalGrams < 1000 },
    { value: "5", label: `5 ${t("years")}` },
    { value: "10", label: `10 ${t("years")}`, disabled: inputData.totalGrams < 100 },
  ];

  const currencyOptions = CURRENCIES.map((c) => ({ value: c, label: c }));

  const paymentMethodOptions = [
    { value: "Wire Transfer", label: t("wireTransfer") },
    { value: "Usdt Tron", label: `USDT ${t("on")} Tron` },
    { value: "Usdt Polygon", label: `USDC ${t("on")} Polygon` },
    { value: "Bitcoin", label: `Bitcoin ${t("on")} Bitcoin` },
    { value: "Ethereum", label: `Ethereum ${t("on")} Ethereum` },
  ];

  const renderFlagItem = (flag, isDisabled = false) => (
    <Form.Check
      key={flag.name}
      className="d-flex align-items-start mb-2"
      type="checkbox"
      name={flag.name}
      id={`term-${flag.name}`}
      disabled={isDisabled}
      checked={!!inputData[flag.name] && !isDisabled}
      onChange={handleChange}
      label={
        <div style={{ opacity: isDisabled ? 0.45 : 1 }}>
          <div
            className="fw-semibold"
            style={{ fontSize: "0.84rem", color: "#e4e6eb", lineHeight: 1.25 }}
          >
            {flag.code} &ndash; {flag.title}
            {flag.reference && (
            <span
              className="fst-italic px-1"
              style={{ fontSize: "0.72rem", color: "#737a85" }}
            >
              ({flag.reference})
            </span>
          )}
          </div>
          <div
            className="mt-1"
            style={{ fontSize: "0.78rem", color: "#a6adb7", lineHeight: 1.35 }}
          >
            {flag.customText || flag.text}
          </div>
          
        </div>
      }
    />
  );

  return (
    <Accordion className="purchase-page" defaultActiveKey="0">
      <Accordion.Item eventKey="0">
        <Accordion.Header>
          <small>Step 1</small>
          <span>{t("purchaseIngot")}</span>
        </Accordion.Header>
        <Accordion.Body>
          <Form.Group className="mb-3">
            <Form.Check
              type="radio"
              label={t("purchaseWithCase")}
              name="type"
              value="custody"
              checked={inputData.type === "custody" ? true : false}
              onChange={(e) => handleChange(e)}
            />
            <Form.Check
              type="radio"
              name="type"
              label={
                <>
                  {t("purchaseWithHomeDelivery")}
                  <br />
                  <small>*{t("homeDeliveryNote")}</small>
                </>
              }
              value="home_delivery"
              checked={inputData.type === "home_delivery" ? true : false}
              onChange={(e) => handleChange(e)}
            />
          </Form.Group>
          <div className="table-responsive">
            <Table className="hOne-input-data">
              <thead>
                <tr>
                  <th>{t("ingot")}</th>
                  <th>{t("quantity")}</th>
                  <th>{t("goldCost")}</th>
                  <th>{t("manufacturing2")}</th>
                  <th>{t("total")}</th>
                </tr>
              </thead>
              <tbody>
                {inputData.ingots.map((item, i) => (
                  <tr key={i}>
                    <td className="text-light">{item.ingot}gr</td>
                    <td className="text-light">
                      <Form.Control
                        type="number"
                        name="quantity"
                        value={item.quantity}
                        onChange={(e) => handleChange(e, i)}
                        min="0"
                      />
                    </td>
                    <td className="text-light">
                      {currencySymbol} {conv(item.goldCost)}
                    </td>
                    <td className="text-light">
                      {currencySymbol} {conv(item.manufacturingCost)}
                    </td>
                    <td className="text-light">
                      {currencySymbol} {conv(item.totalCost)}
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </div>
          {inputData.type === "custody" && (
            <Form.Group as={Col} xs={12} md={6} className="mb-3">
              <Form.Label>{t("caseDuration")}</Form.Label>
              <SelectInput
                name="duration"
                options={durationOptions}
                value={inputData.duration}
                onChange={handleChange}
                placeholder={t("select")}
              />
            </Form.Group>
          )}
          <Form.Group as={Col} xs={12} md={6} className="mb-3">
            <Form.Label>{t("currency")}</Form.Label>
            <SelectInput
              name="currency"
              options={currencyOptions}
              value={currency}
              onChange={(e) => setCurrency(e.target.value)}
              placeholder={t("select")}
            />
          </Form.Group>
        </Accordion.Body>
      </Accordion.Item>
      <Accordion.Item eventKey="1">
        <Accordion.Header>
          <small>Step 2</small>
          <span>{t("termsAndConditions")}</span>
        </Accordion.Header>
        <Accordion.Body>
          <PdfViewer file={fileToDisplay} />
          <div className="mt-3">
            {tncFlags.map((flag) => renderFlagItem(flag))}
          </div>
        </Accordion.Body>
      </Accordion.Item>
      <Accordion.Item eventKey="2">
        <Accordion.Header>
          <small>Step 3</small>
          <span>{t("paymentMethod")}</span>
        </Accordion.Header>
        <Accordion.Body>
          <SelectInput
            name="paymentMethod"
            options={paymentMethodOptions}
            value={inputData.paymentMethod}
            onChange={handleChange}
            placeholder={t("select")}
          />
        </Accordion.Body>
      </Accordion.Item>
      <Accordion.Item eventKey="3">
        <Accordion.Header>
          <small>Step 4</small>
          <span>{t("downloadEosKey")}</span>
        </Accordion.Header>
        <Accordion.Body>
          {!eosKey?.isAvailable && (
            <div className="mt-3 pt-3 border-top border-secondary">
              <EosKey refetch={refetch} />
            </div>
          )}
          <div className="mt-3">
            {blockchainFlags.map((flag) => {
              const isDisabled = flag.dependsOn && !inputData[flag.dependsOn];
              return renderFlagItem(flag, isDisabled);
            })}
          </div>
        </Accordion.Body>
      </Accordion.Item>
    </Accordion>
  );
};

export default HOnePurchaseForm;
